<div class="ace" [ace]="config" (valueChange)="onValueChange($event)" (change)="onContentChange($event)" style="height: 1000px"></div>
